/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SessionmanagementService } from './sessionmanagement.service';

@Injectable({
  providedIn: 'root'
})
export class SideNavConfigService {

  private sideNavList:any = [];

  private updatedNav:any[] = [];
  private readonly sideNav = new BehaviorSubject(this.sideNavList);
  public $sideNavMenu = this.sideNav.asObservable();
  public sidebarNav = signal<any>([]);
  toggleMenu =  signal(false);
  readonly activeReportId = signal<number | null>(null);

  constructor(private readonly httpsrv: HttpClient, private readonly sessionConfig: SessionmanagementService) {}

  public getSideNavbarList() {
    this.httpsrv.get('assets/json/menu.json').subscribe({
      next: (response: any) => {
        if (this.sessionConfig.isAdmin) {
          this.sideNavList = response.admin;
        } else {
          this.sideNavList = response.other;
        }
        this.updatedNav = [...this.sideNavList];
        this.sidebarNav.set(this.updatedNav);
      }
    });
  }

  updateLeftNav(navItem: any) {
    if(navItem){
      this.updatedNav.push(navItem);
    }else {
      this.updatedNav.pop();
    }
    
    this.sideNav.next(this.updatedNav);
    this.sidebarNav.update(() => this.updatedNav);
  }

  updateLeftNavOnPop(navItem: any) {
    this.updatedNav = this.updatedNav.filter(item => item.data?.report_id !== navItem);
    this.sideNav.next(this.updatedNav);
    this.sidebarNav.update(() => this.updatedNav);

    if (this.activeReportId() === navItem) {
      this.setActiveReport(null);
    }
  }

  setActiveReport(id: number | null) {    
    this.activeReportId.set(id ?? null);
  }

  isActiveReport(id?: number | null): boolean {
    const active = this.activeReportId();    
    return !!id && active === id;
  }

  getActiveReportId(): number | null {
    return this.activeReportId();
  }

}
